import { render, staticRenderFns } from "./ticket-list-item.vue?vue&type=template&id=0d37ce7c&scoped=true"
import script from "./ticket-list-item.vue?vue&type=script&lang=js"
export * from "./ticket-list-item.vue?vue&type=script&lang=js"
import style0 from "./ticket-list-item.vue?vue&type=style&index=0&id=0d37ce7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37ce7c",
  null
  
)

export default component.exports